module.exports = "https://images.shiksha.ws/saassets/media/Arrow-Red.8258b406.png";